import React from 'react';
import NavbarComponent from './NavbarComponent';

// Define the functional component
const AboutPage = () => {

  return (
    <div className="App">
      <NavbarComponent />   
      <h2>About</h2>
      <p>I am a landscape, cityscape, and aviation photographer based in Boston, Massachusetts.</p>
      <p>My work is shot on a mix of digital and 35mm film.</p>
    </div>
  );
};

export default AboutPage;